module.exports = __webpack_public_path__ + "img/KaiLiPhD.65ce0cad.png";